import * as angular from 'angular';
import {RootScope} from '../../types/angular-types';
import AppConstants from '../../gorillaboy/AppConstants';

import './empty_task_list.html';

angular.module('GorillaBoy.Tasks')
    .directive('emptyTaskList', [
        '$rootScope',
        '$translate',
        function emptyTaskList($rootScope: RootScope, $translate: ng.translate.ITranslateService) {
        return {
            restrict: 'E',
            templateUrl: './tasks/empty_task_list/empty_task_list.html',
            scope: {
                view: '<',
            },
            link: function($scope, $element, attrs) {
                $scope.getEmptyMessage = function() {
                    if ($scope.view === AppConstants.Tasks.Views.AssignedTasks) {
                        return $translate.instant('TASKS.LIST_VIEW.NO_ASSIGNED_TASKS_TO_DISPLAY');
                    }
                    return $translate.instant('TASKS.LIST_VIEW.NO_TASKS_TO_DISPLAY');
                };
            }
        };
    }])